// extracted by mini-css-extract-plugin
export var button = "_ef-4";
export var hasDarkBackground = "_ef-7";
export var hasLightBackground = "_ef-6";
export var iconWrapper = "_ef-0";
export var large = "_ef-2";
export var medium = "_ef-1";
export var small = "_ef-5";
export var xsmall = "_ef-3";